import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";
import { PolizasVencidasNoLiberadasEntity } from "../entities/polizas-vencidasnoLiberadas_entity";


@Pipe({
    name: "dataFilterPoliza"
})
export class DataFilterPipe implements PipeTransform {

    transform(array: PolizasVencidasNoLiberadasEntity[], query: string): any {
        if (query) {
            return _.filter(array, row=> (row.PolCod+"").indexOf((query)) > -1);
        }
        return array;
    }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.filter.ts